import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: 'communityIdentificationCodeTypes',
      method: 'get',
      request: communityId => ({
        url: apiRoutes.communityIdentificationCodeTypes(communityId),
      }),
    },
  ])(ComposedComponent);
